import {
  AvailablePitchTypesAndGroupsDto,
  BatterSingleSessionReportChartConfigDto,
  BatterSingleSessionReportChartDataDto,
  DateRangeDto,
  PlayerReportContentConfigDto,
  SelectedItemDto,
} from 'types/CodegenReportTypes';
import { configurablePitchTypeGroups, configurablePitchTypes } from 'utilities/constants';

import { generateStore } from 'utilities/reportStoreFactory';

type ReportSpecificTypes = {
  // search criteria come from select fields and their type must match selected entries from ...FilterDto type
  searchCriteria: {
    gameType: SelectedItemDto | undefined;
    dateRanges: DateRangeDto[] | undefined;
    seasonNames: string[] | undefined;
    level: SelectedItemDto | undefined;
    team: SelectedItemDto | undefined;
    players: SelectedItemDto[] | undefined;
    sessions: SelectedItemDto[] | undefined;
  };
  // search chips type must match selected entries from ...ResultDto type
  searchChips: {
    seasonNames: string[] | undefined;
    dateRanges: DateRangeDto[] | undefined;
    levelName: string | undefined;
    teamName: string | undefined;
    playerNames: string[] | undefined;
    sessionNames: string[] | undefined;
  };

  // filters / config area
  specialConfigOptions: { pitchTypeInfo: AvailablePitchTypesAndGroupsDto } | undefined;
  selectedConfgValues: PlayerReportContentConfigDto;

  // charts area
  layout: BatterSingleSessionReportChartConfigDto | undefined;
  chartData: BatterSingleSessionReportChartDataDto[] | undefined;
};

const defaultValues: ReportSpecificTypes = {
  // search criteria area
  searchCriteria: {
    gameType: { id: 'All', name: 'All' },
    dateRanges: undefined,
    seasonNames: undefined,
    level: undefined,
    team: undefined,
    players: undefined,
    sessions: undefined,
  },
  searchChips: {
    seasonNames: undefined,
    dateRanges: undefined,
    levelName: undefined,
    teamName: undefined,
    playerNames: undefined,
    sessionNames: undefined,
  },

  // filters / config area
  specialConfigOptions: undefined,
  selectedConfgValues: {
    pitchTagging: 'Auto',
    playerHandedness: 'Both',
    pitchGrouping: 'Types',
    pitchTypes: configurablePitchTypes,
    pitchTypeGroups: configurablePitchTypeGroups,
  },

  // charts area
  layout: undefined,
  chartData: undefined,
};

const useReportStore = generateStore(defaultValues);

export default useReportStore;
